import { FadeUp } from "./Reveal";

export const Footer = () => (
  <footer className="border-t border-white/10" data-testid="footer">
    <FadeUp>
      <div className="px-6 md:px-12 py-16 md:py-24 flex flex-col md:flex-row justify-between gap-12">
        <div>
          <img src="/assets/etmb-logo.png" alt="ETMB Design Build" className="h-20 md:h-28 w-auto" data-testid="footer-logo" />
          <p className="mt-6 max-w-xs text-sm font-light text-ash leading-relaxed">
            Design-build practice. Architecture and construction, delivered by one accountable team.
          </p>
        </div>
        <div className="flex gap-20 text-sm">
          <div>
            <div className="text-xs tracking-[0.3em] uppercase text-ash mb-5">Sitemap</div>
            <ul className="space-y-3 font-light">
              {[["Work", "#work"], ["Studio", "#studio"], ["Services", "#services"], ["Contact", "#contact"]].map(([label, href]) => (
                <li key={label}>
                  <a href={href} className="link-line" data-testid={`footer-link-${label.toLowerCase()}`}>{label}</a>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <div className="text-xs tracking-[0.3em] uppercase text-ash mb-5">Contact</div>
            <ul className="space-y-3 font-light">
              <li><a href="mailto:LonnyLBradley@gmail.com" className="link-line" data-testid="footer-email-link">LonnyLBradley@gmail.com</a></li>
              <li><a href="mailto:Lbradley@etmbdesignbuild.com" className="link-line" data-testid="footer-email-link-2">Lbradley@etmbdesignbuild.com</a></li>
              <li><a href="tel:+12029975954" className="link-line" data-testid="footer-phone-link">202.997.5954</a></li>
              <li className="text-ash">Burke, VA</li>
              <li className="text-ash text-xs leading-relaxed" data-testid="footer-licensing">
                Licensed &amp; Insured: Washington DC,<br />Virginia, Florida, Maryland (pending)<br />&amp; New York (pending)
              </li>
            </ul>
          </div>
        </div>
      </div>
    </FadeUp>
    <div className="border-t border-white/10 px-6 md:px-12 py-6 flex flex-col md:flex-row justify-between gap-3 text-[10px] tracking-[0.3em] uppercase text-ash">
      <span data-testid="footer-copyright">© 2026 ETMB Design Build PLLC</span>
      <span className="flex items-center gap-6">
        <span>Design + Build — One Team</span>
        <a href="/admin" className="text-ash/50 hover:text-paper transition-colors" data-testid="footer-admin-link">Admin</a>
      </span>
    </div>
  </footer>
);
